<div
  class="overflow-y-auto h-full"
  (resize)="handleResize($event)"
  resizeDelayType="debounce"
  appSelectableList
  #appSelectableList="appSelectableList"
  [appSelectableListReset]="eventsChanged$"
  >
  @if (size) {
    <stch-calendar-month
      class="calendar"
      [ngClass]="size"
      [viewDate]="viewDate"
      [selectedDate]="selectedDate"
      [events]="calendarEvents()"
      [scrollToDate]="scrollToDate()"
      [eventsAppearance]="size === 'l' ? 'list' : 'dots'"
      (dateClicked)="dateClicked.emit($event)"
      (dateDblClicked)="dateDblClicked.emit($event)"
      (eventDropped)="eventDropped.emit($event)"
      (eventClicked)="eventClicked.emit($event)"
      (eventDblClicked)="eventDblClicked.emit($event)"
      />
  }
</div>
